<template>
    <el-select
      v-model="contact"
      :size="size || 'mini'"
      :clearable="clearable || false"
      :placeholder="''"
      :disabled="disabled || false"
      :remote="remote || false"
      :remote-method="remoteMethod"
      @change="(ev) => selectChange(ev)"
      :filterable="filterable || false"
      :multiple="multiple || false"
      :collapse-tags="collapseTags || false"
      style="width:100%"
    >
      <el-option v-for="(item, index) in option" :value="item.id" :label="item.name" :key="index" />
    </el-select>
</template>

<script>
export default {
  props:['value','multiple','filterable','remoteMethod', 'collapseTags','remote','disabled','placeholder','clearable','size'],
  data(){
    return {
      option:[],
      contact: ''
    }
  },
  watch: {
    value(val) {
      if(!val) {
        this.contact = ''
      } else {
        this.contact = val
      }
    }
  },
  created(){
    this.getAddContactList()
  },
  methods: {
    //新增联系人接口
    getAddContactList() {
      const url = 'rest/store/contact/v3/contactpersons/query'
      this.$axios.$post(url, {
        current: 1,
        page_size: 10000
      }).then(({data, code}) => {
        if (code !== 200) return;
        this.option = data.list.map( res => {
          const { display_name} = res
          return {
            ...res,
            name:display_name,
          }
        })
      });
    },
    selectChange(value) {
      //当前这一条
      const option = this.option.find(({ id }) => id === value);
      this.$emit('input', value)
      this.$emit('selectChange',value, {option});
    }
  }
};
</script>

<style lang="less" scoped>
</style>
